import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit,faUserUnlock} from '@fortawesome/pro-light-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { ColumnProps, SortOrder } from 'antd/lib/table';
import { Sorting } from 'src/types/Sorting';
import { ProxyCredential } from 'src/types/ProxyServiceInfo';
import ServiceStatusConfirmation from '../ServiceStatusConfirmation';
import styles from '../ServiceList.module.less';

type ColumnConfig = ColumnProps<ProxyCredential> & {
  customColRenderer?: (dataIndex: ProxyCredential) => React.ReactNode;
};

const faEditIcon = faEdit as IconProp;
const faUserPenIcon = faUserUnlock as IconProp;

export const sortOrder = (
  sortedInfo: Sorting<ProxyCredential> | null,
  key: keyof ProxyCredential
): SortOrder | boolean => {
  return sortedInfo && sortedInfo.field === key ? sortedInfo.order : false;
};

export const enabledStatusRender = (record: ProxyCredential, handleToggleChange: any) => {
  return (
    <p className={styles.status_icon}>
      <ServiceStatusConfirmation
        record={record}
        handleToggleChange={(newStatus) => {
          const updatedRecord = { ...record, enabled: newStatus };
          handleToggleChange(updatedRecord);
        }}
      />
    </p>
  );
};

// export const ipErrorStatusRender = (record: { ipErrorEnabled: boolean }, onAction: any) => {
//   return (
//     <p className={styles.status_icon}>
//       {record.ipErrorEnabled === true ? (
//         <FontAwesomeIcon
//           onClick={() => onAction(record)}
//           icon={faToggleOn}
//           className={styles.status_active_icon}
//           size="lg"
//         />
//       ) : (
//         <FontAwesomeIcon
//           onClick={() => onAction(record)}
//           icon={faToggleOff}
//           className={styles.status_inactive_icon}
//           size="lg"
//         />
//       )}
//     </p>
//   );
// };

export const actionRender = (record: ProxyCredential, onAction: any) => {
  const onIconClick = (type: string) => {
    return () => {
      onAction(record, type);
    };
  };

  return (
    <>
      <FontAwesomeIcon
        icon={faUserPenIcon}
        className={styles.actionIcon}
        title={'Edit User Credential'}
        onClick={onIconClick('editUserService')}
      />
      <FontAwesomeIcon
        icon={faEditIcon}
        className={styles.actionIcon}
        title={'Edit Proxy Configuration'}
        onClick={onIconClick('editConfigurationService')}
      />
    </>
  );
};

export const getColumns = (
  sorting: Sorting<ProxyCredential> | null,
  onAction?: (record: ProxyCredential, type: string) => void,
  onChangeStatus?: (record: ProxyCredential, newStatus: boolean) => void
) => {
  const columns: ColumnConfig[] = [
    {
      title: 'Proxy Service Name',
      key: 'proxyServiceName',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record) => <span>{record.proxyName}</span>,
      sortOrder: sortOrder(sorting, 'proxyServiceName'),
      sorter: true,
      width: 250,
    },
    {
      title: 'Port',
      key: 'port',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record) => <span>{record.port}</span>,
      sortOrder: sortOrder(sorting, 'port'),
      sorter: true,
      width: 100,
    },
    {
      title: 'Enabled',
      key: 'enabled',
      defaultSortOrder: 'ascend',
      sortDirections: ['ascend', 'descend', 'ascend'],
      render: (record) => enabledStatusRender(record, onChangeStatus),
      sortOrder: sortOrder(sorting, 'enabled'),
      sorter: true,
      width: 120,
    },
    // {
    //   title: 'IP Error Handling',
    //   key: 'ipErrorHandle',
    //   defaultSortOrder: 'ascend',
    //   sortDirections: ['ascend', 'descend', 'ascend'],
    //   render: (record) => ipErrorStatusRender(record, onAction),
    //   sortOrder: sortOrder(sorting, 'ipErrorEnabled'),
    //   sorter: true,
    //   width: 120,
    // },
    {
      title: 'Actions',
      key: 'actions',
      render: (record) => actionRender(record, onAction),
      width: 120,
    },
  ];

  return columns;
};
